import { BASE_GATEWAY_URI } from "../constants";
import { get } from "axios";

async function findIfAccountExists(address, kit) {
  if (!address) return;
  try {
    const accounts = await kit.contracts.getAccounts();
    const isAccount = await accounts.isAccount(address);

    console.log("isAccount", isAccount);
  } catch (err) {
    console.log(err.message);
  }
}

export async function ensureAccount(address, kit, performActions) {
  if (!address) return;
  try {
    const isAccount = await findIfAccountExists(address, kit);

    if (isAccount) return;
    await performActions(async (kit) => {
      const accounts = await kit.contracts.getAccounts();
      const res = await accounts.createAccount().sendAndWaitForReceipt({
        from: address,
      });
      console.log(await res);
    });
  } catch (err) {
    console.log(err);
  }
}

export async function getMetadata(uri) {
  const resp = await get(`${BASE_GATEWAY_URI}${uri.replace("ipfs://", "")}`);
  return resp.data;
}
